import React from 'react';
import { Section } from './ui/Section';
import { UserPlus, Search, Sliders, ArrowRight } from 'lucide-react';
export function PersonalizedHelp() {
  return <Section className="bg-white rounded-3xl shadow-sm border border-sage-light/30 my-12" data-id="element-130">
      <div className="max-w-4xl mx-auto" data-id="element-131">
        <div className="text-center mb-10" data-id="element-132">
          <div className="inline-flex items-center justify-center px-4 py-2 rounded-full bg-primary/10 text-primary font-medium text-sm mb-6 uppercase tracking-wider" data-id="element-133">
            Optional Upgrade
          </div>
          <h2 className="text-3xl md:text-4xl font-bold text-primary-dark mb-6" data-id="element-134">
            Plus: Get Personalized Help If You Want It
          </h2>
          <p className="text-xl text-charcoal/80 font-serif italic" data-id="element-135">
            Your body is unique. Your needs, goals, lifestyle, and current
            supplement routine are different from everyone else’s.
          </p>
        </div>

        <p className="text-center text-lg text-charcoal/80 mb-10" data-id="element-136">
          That’s why, in addition to the guide, you also have the option to
          contact me for a personalized supplement analysis.
        </p>

        <div className="grid md:grid-cols-2 gap-6 mb-10" data-id="element-137">
          <div className="flex items-start gap-4 p-6 bg-cream rounded-2xl" data-id="element-138">
            <Search className="text-primary shrink-0 mt-1" size={24} data-id="element-139" />
            <p className="text-lg font-medium" data-id="element-140">
              Review the supplements you are currently taking and check whether
              your brands are high quality.
            </p>
          </div>
          <div className="flex items-start gap-4 p-6 bg-cream rounded-2xl" data-id="element-141">
            <Sliders className="text-primary shrink-0 mt-1" size={24} data-id="element-142" />
            <p className="text-lg font-medium" data-id="element-143">
              Optimize your routine and recommend better options based on your
              specific goals.
            </p>
          </div>
        </div>

        <div className="text-center bg-primary/5 p-6 rounded-2xl" data-id="element-144">
          <p className="text-xl font-serif text-primary-dark font-semibold" data-id="element-145">
            So you’re not left trying to figure everything out alone.
          </p>
        </div>
      </div>
    </Section>;
}